<template>
  <div>
    <!-- {{ perm }} -->
    <v-card-title>
      <v-spacer></v-spacer>
      <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
    </v-card-title>
    <v-data-table :loading="loading" :search="search" :items="items" :headers="headers">
      <template v-slot:[`item.id`]="{ item }">
        {{ item.std_id }}
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <v-btn @click="showDialog(item)" small>
          <!-- <v-icon dark>mdi-plus</v-icon> -->
          Add Details
        </v-btn>
        <v-btn v-if="item.user_id == '0'" color="green" @click="showDialog2(item)" small>
          <!-- <v-icon dark>mdi-plus</v-icon> -->
          Set Username
        </v-btn>
      </template>
      <template v-slot:[`item.delete`]="{ item }">
        <router-link class="profile-link" active-class :exact="true" :disabled="perm.r_edit" :event="perm.r_edit ? 'click' : ''"
          :to="{ name: 'EditJoinedStudent', params: { id: item.std_id } }">
          <v-icon color="success" :disabled="!perm.r_edit">mdi-file-edit</v-icon>
        </router-link>
        <v-icon color="red" :disabled="!perm.r_delete" @click="confirmDelete(item)">mdi-delete</v-icon>
      </template>
      <template v-slot:[`item.name`]="{ item }">
        <v-btn text color="primary">
          <router-link class="profile-link" active-class="active" :exact="true"
            :to="{ name: 'StudentProfile', params: { id: item.std_id } }">
            <span class="table-tutor-name">{{ item.std_fname }} {{ item.std_lname }}</span>
            <!-- <span class="table-tutor-email">{{item.tutor_email}}</span> -->
          </router-link>
        </v-btn>
      </template>
      <template v-slot:[`item.father_name`]="{ item }">{{ item.gaurdian_fname }} {{ item.gaurdian_lname }}</template>
      <template v-slot:[`item.phone_number`]="{ item }">{{
          item.gaurdian_contactno
      }}</template>
      <template v-slot:[`item.class_name`]="{ item }">{{
          item.school_year.school_year_name
      }}</template>
      <template v-slot:[`item.created_at`]="{ item }">{{
          item.creation_time
      }}</template>
      <!-- <template v-slot:[`item.discount`]="{ item }">
        <v-btn @click="addDiscount(item)" small color="#15BEDF">
          <v-icon>mdi-tag mdi-rotate-90</v-icon>Discount
        </v-btn>
      </template>
      <template v-slot:[`item.tutor`]="{ item }">
        <v-btn @click="tutor_assign_dialog=true" small color="#F0CB00">Class And Tutor Assigned</v-btn>
      </template> -->
    </v-data-table>
    <!-- <div class="pa-2 d-flex justify-end">
      <span class="pa-2">
        Total Students
        <span :style="{'color':this.$vuetify.theme.themes.light.primary}">{{count}}</span>
      </span>
      <v-spacer></v-spacer>
      <v-pagination circle v-model="page" :length="totalPages"></v-pagination>
    </div> -->
    <v-dialog v-model="dialog" persistent max-width="600px">
      <!-- <template v-slot:activator="{ on, attrs2 }">
          
          <v-btn color="#6A158E" dark  v-bind="attrs2"
          v-on="on">+ Add Session</v-btn>
        </template> -->
      <v-card>
        <v-card-title>
          <span class="headline">Add Details</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col>
                <v-select v-model="data.selected_class" :items="classes" hide-selected label="Select Class" small-chips
                  item-value="class_id" item-text="class_name">
                </v-select>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <label class="custom-label">Joining Date</label>

                <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false"
                  :return-value.sync="data.joining_date" transition="scale-transition" offset-y min-width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="data.joining_date" label="Choose Date" :error-messages="errors.joining_date"
                      prepend-icon readonly v-bind="attrs" v-on="on" solo></v-text-field>
                  </template>
                  <v-date-picker :first-day-of-week="1" v-model="data.joining_date" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
                    <v-btn text color="primary" @click="$refs.menu2.save(data.joining_date)">OK</v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col>
                <label class="custom-label">Ending Date</label>

                <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false"
                  :return-value.sync="data.ending_date" transition="scale-transition" offset-y min-width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="data.ending_date" label="Choose Date" :error-messages="errors.ending_date"
                      prepend-icon readonly v-bind="attrs" v-on="on" solo></v-text-field>
                  </template>
                  <v-date-picker :first-day-of-week="1" v-model="data.ending_date" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
                    <v-btn text color="primary" @click="$refs.menu1.save(data.ending_date)">OK</v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <label class="custom-label">Date of birth</label>

                <v-menu ref="menu3" v-model="menu3" :close-on-content-click="false"
                  :return-value.sync="data.date_of_birth" transition="scale-transition" offset-y min-width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="data.date_of_birth" label="Choose Date"
                      :error-messages="errors.date_of_birth" prepend-icon readonly v-bind="attrs" v-on="on" solo>
                    </v-text-field>
                  </template>
                  <v-date-picker :first-day-of-week="1" v-model="data.date_of_birth" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
                    <v-btn text color="primary" @click="$refs.menu3.save(data.date_of_birth)">OK</v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>

              <v-col>
                <label class="custom-label">Discount</label>

                <v-row>
                  <v-col style="padding-top: 0">
                    <v-text-field v-model="data.discount" :error-messages="errors.mon_hours" label="Discount"
                      placeholder="Discount" solo></v-text-field>
                  </v-col>
                  <v-col style="padding-top: 0">
                    <v-checkbox v-model="data.discount_type" class="mx-2" label="Percentage"></v-checkbox>
                  </v-col>
                </v-row>
              </v-col>

              <!--      <v-text-field
                v-model="data.number_of_hours"
                :error-messages="errors.number_of_hours"
                label="Number Of Hours Per Week"
                placeholder="Number Of Hours Per Week"
                solo
              ></v-text-field> -->
            </v-row>
            <v-row>
              <v-col>
                <label class="custom-label">Number Of Hours</label>
              </v-col>
            </v-row>
            <v-row style="width: fit-content">
              <v-col> Monday </v-col>
              <v-col>
                <v-text-field v-model="data.mon_hours" :error-messages="errors.mon_hours" label="No Of Hours"
                  placeholder="No Of Hours" solo dense></v-text-field>
              </v-col>
              <v-col> Tuesday </v-col>
              <v-col>
                <v-text-field v-model="data.tue_hours" :error-messages="errors.tue_hours" label="No Of Hours"
                  placeholder="No Of Hours" solo dense></v-text-field>
              </v-col>
            </v-row>

            <v-row style="width: fit-content">
              <v-col> Wednesday </v-col>
              <v-col>
                <v-text-field v-model="data.wed_hours" :error-messages="errors.wed_hours" label="No Of Hours"
                  placeholder="No Of Hours" solo dense></v-text-field>
              </v-col>
              <v-col> Thursday </v-col>
              <v-col>
                <v-text-field v-model="data.thu_hours" :error-messages="errors.thu_hours" label="No Of Hours"
                  placeholder="No Of Hours" solo dense></v-text-field>
              </v-col>
            </v-row>

            <v-row style="width: fit-content">
              <v-col> Friday </v-col>
              <v-col>
                <v-text-field v-model="data.fri_hours" :error-messages="errors.fri_hours" label="No Of Hours"
                  placeholder="No Of Hours" solo dense></v-text-field>
              </v-col>

              <v-col> Saturday </v-col>
              <v-col>
                <v-text-field v-model="data.sat_hours" :error-messages="errors.sat_hours" label="No Of Hours"
                  placeholder="No Of Hours" solo dense></v-text-field>
              </v-col>
            </v-row>

            <v-row style="width: fit-content">
              <v-col> Sunday </v-col>
              <v-col>
                <v-text-field v-model="data.sun_hours" :error-messages="errors.sun_hours" label="No Of Hours"
                  placeholder="No Of Hours" solo dense></v-text-field>
              </v-col>

              <v-col style="opacity: 0"> Sunday </v-col>
              <v-col style="opacity: 0">
                <v-text-field v-model="data.no_hours" :error-messages="errors.no_hours" label="No Of Hours"
                  placeholder="No Of Hours" solo dense></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false">Close</v-btn>
          <v-btn color="blue darken-1" text @click="chooseCLass">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog2" persistent max-width="600px">
      <!-- <template v-slot:activator="{ on, attrs2 }">
          
          <v-btn color="#6A158E" dark  v-bind="attrs2"
          v-on="on">+ Add Session</v-btn>
        </template> -->
      <v-card>
        <v-card-title>
          <span class="headline">Set Username</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col>
                <label class="custom-label">Username</label>

                <v-text-field v-model="data.username" :error-messages="errors.username" label="Username"
                  placeholder="Username" solo></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog2 = false">Close</v-btn>
          <v-btn color="blue darken-1" text @click="setUsername">Send Email</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-overlay :value="overlay" style="z-index: 99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <delete-dialog @success="deleteGroup" :confirm-loading="deleteConfirmLoading" @closeDialog="cancelDelete"
      :dialog="delete_dialog" title="Group"></delete-dialog>
  </div>
</template>

<script>
// import DiscountDialog from "./DiscountDialog";
// import TutorAssignmentForm from "./TutorAssignmentForm";
import DataTableMixin from "../../mixins/dataTable";
import Form from "../../utils/form";
import DeleteDialog from "../Dialogs/DeleteDialog";
import DeleteRow from "../../mixins/deleteRow";

export default {
  props: ['perm'],
  name: "JoinedTable",
  components: {
    DeleteDialog,
  },
  mixins: [DataTableMixin, DeleteRow],
  data() {
    return {
      search: "",
      overlay: false,
      errors: {},
      data: {},
      menu1: false,
      menu2: false,
      menu3: false,
      dialog: false,
      dialog2: false,
      student_id: "",
      classes: [],
      selectedClass: "",
      currentRow: 0,
      loading: true,
      discount_dialog: false,
      tutor_assign_dialog: false,
      page: 1,
      pageCount: 3,
      itemsPerPage: 10,
      headers: [
        // { text: "SRNO", sortable: true, value: "id" },
        {
          text: "Student Id",
          sortable: true,
          value: "id",
        },
        {
          text: "Name",
          value: "name",
          sortable: true,
        },
        {
          text: "Father Name",
          value: "father_name",
          sortable: true,
        },
        {
          text: "Phone Number",
          value: "phone_number",
          sortable: true,
        },
        {
          text: "Class",
          value: "class_name",
          sortable: true,
        },
        // {text: "Class", value: "class.class_name", sortable: true},
        {
          text: "Enquiry At",
          value: "created_at",
          sortable: true,
        },
        // { text: "Discount", value: "discount", sortable: true },
        // { text: "Class and tutor assigned", value: "tutor", sortable: true },
        // {text: "Action", value: "action", sortable: true},
        {
          text: "Action",
          value: "delete",
          sortable: true,
        },
        {
          text: "Full Name",
          value: "full_name",
          align: " d-none",
        },
      ],
    };
  },
  methods: {
    deleteGroup() {
      // console.log(this.current_row);
      axios
        .get("/joined/students/remove/" + this.current_row.std_id)
        .then((response) => {
          // this.getItems()
          this.deleteConfirmLoading = false;
          this.delete_dialog = false;
          this.getItems();
        })
        .catch((error) => {
          this.deleteConfirmLoading = false;
          this.delete_dialog = false;
          // Toast.fire({
          //     icon: 'error',
          //     title: 'Cannot Deleted Linked Groups!',
          // })
        });
    },
    cancelDelete() {
      this.deleteConfirmLoading = false;
      this.delete_dialog = false;
    },
    setUsername() {
      let form = new Form({
        ...this.data,
      });
      this.overlay = true;
      form
        .post("set/username")
        .then((response) => {
          console.log(response);
          // this.formalizeTable(response.data);
          this.dialog2 = false;
          this.getItems();
          this.overlay = false;

          // console.log(response)
          // this.classes = response.data.response
        })
        .catch((response) => {
          this.overlay = false;

          console.log(response);
          if (response.status === 400) {
            this.errors = response.data;
          }
          // alert(response.status)
          if (response.status === 422) {
            //    console.log(response.data)
            this.errors = response.data.errors;
          }
          this.loading = false;
        });
    },
    chooseCLass() {
      // var data = {
      //   "student_id" : this.student_id,
      //   "class_id" : this.selectedClass
      // }
      axios.post("select/class", this.data).then((response) => {
        // this.formalizeTable(response.data);
        this.dialog = false;
        this.getItems();
        // console.log(response)
        // this.classes = response.data.response
      });
    },
    showDialog2(item) {
      this.data.student_id = item.std_id;
      this.dialog2 = true;
    },
    showDialog(item) {
      console.log(item);
      this.dialog = true;
      axios.get("classes").then((response) => {
        // this.formalizeTable(response.data);
        // this.loading = false;
        console.log(response);
        this.classes = response.data.response;
        this.data.student_id = item.std_id;
        this.data.joining_date = item.std_joining_date;
        this.data.ending_date = item.std_leaving_date;
        this.data.date_of_birth = item.std_dob;
        this.data.number_of_hours = item.std_no_of_hours;
        this.data.selected_class = parseInt(item.class_id);
      });
    },
    getItems() {
      axios
        .get(apiRoutes.students.assessmentRecordUrl, {
          params: {
            type: "joined",
          },
        })
        .then((response) => {
          // this.formalizeTable(response.data);
          this.items = response.data.response;
          this.loading = false;
        });
    },
    addDiscount(item) {
      this.currentRow = item.user_id;
      this.discount_dialog = !this.discount_dialog;
    },
    cancelDiscount() {
      this.currentRow = 0;
      this.discount_dialog = !this.discount_dialog;
    },
  },
  mounted() {
    this.getItems();
  },
};
</script>

<style scoped>
</style>
